import React from "react";
import './Calculator.css';

import { Slider } from '@material-ui/core';
import Tooltip from "../Tooltip";

function CCSlider({style, value,onChange, questionConfig, children, isChildrenAfter}) {

  const tooltipContent = questionConfig?.getTooltip 
    ? questionConfig.getTooltip(questionConfig?.rootAlias) 
    : questionConfig.tooltipContent;

return (
    <div style={style} className='cc-question' id={'question-' + questionConfig.rootAlias + questionConfig.alias} key={'question-' + questionConfig.rootAlias + questionConfig.alias}>
      <div className='cc-question-title'>
          {questionConfig.name}
          {tooltipContent && <Tooltip color={'var(--primary-color)'} title={''} content={tooltipContent}/>}
      </div>
      <div className='cc-question-description'>
        {questionConfig?.getDescription
          ? questionConfig.getDescription(questionConfig.rootAlias)
          : questionConfig.description}
      </div>      

      <div className='indent'>

      {!isChildrenAfter && children}

      { questionConfig.getLabel && <div className='cc-input-label' style={{ marginTop: !isChildrenAfter && children ? '1rem' : '' }}> {questionConfig.getLabel(value,questionConfig)} </div> }

        <Slider
          id={'slider-' + questionConfig.alias}
          value={value} valueLabelDisplay={questionConfig.valueLabelDisplay}
          step={questionConfig.step} min={questionConfig.min} max={questionConfig.max} marks={questionConfig.marks}
          onChange={(event,val) => onChange(event, val,questionConfig.alias, questionConfig.rootAlias)}
          valueLabelFormat={questionConfig.valueLabelFormat}
          className="accent-dark-color"
        />

        <div className='sub-labels'>
            <span className='left'>{questionConfig.subLabels[0] }</span>
            <span className='right'>{questionConfig.subLabels[1] }</span>
        </div>

        {isChildrenAfter && children}

      </div>
    </div>
  );
}

export default CCSlider;
